import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { UsersResponse } from "../response/UsersResponse";

interface useUsersProps {
    id: number | undefined;
}

export const useUsers = ({ id }: useUsersProps) => {
    return useQuery({
        queryKey: ['roles', 'users', 'permissions'],
        queryFn: async () => {
            try {
                const response = await privateApi.get('/v4/user', {
                    params: {
                        all: 1,
                    }
                });

                const validationResult = UsersResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Failed to fetch users");
                }
                return validationResult.data;

            } catch (error) {
                console.error("Failed to fetch users", error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};